/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAppointmentHourResponse } from './CreateAppointmentHourResponse';
import {
    CreateAppointmentHourResponseFromJSON,
    CreateAppointmentHourResponseFromJSONTyped,
    CreateAppointmentHourResponseToJSON,
    CreateAppointmentHourResponseToJSONTyped,
} from './CreateAppointmentHourResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateAppointmentHourResponse
 */
export interface ResultOfCreateAppointmentHourResponse {
    /**
     * 
     * @type {CreateAppointmentHourResponse}
     * @memberof ResultOfCreateAppointmentHourResponse
     */
    data: CreateAppointmentHourResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateAppointmentHourResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateAppointmentHourResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateAppointmentHourResponse interface.
 */
export function instanceOfResultOfCreateAppointmentHourResponse(value: object): value is ResultOfCreateAppointmentHourResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateAppointmentHourResponseFromJSON(json: any): ResultOfCreateAppointmentHourResponse {
    return ResultOfCreateAppointmentHourResponseFromJSONTyped(json, false);
}

export function ResultOfCreateAppointmentHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateAppointmentHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateAppointmentHourResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateAppointmentHourResponseToJSON(json: any): ResultOfCreateAppointmentHourResponse {
    return ResultOfCreateAppointmentHourResponseToJSONTyped(json, false);
}

export function ResultOfCreateAppointmentHourResponseToJSONTyped(value?: ResultOfCreateAppointmentHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateAppointmentHourResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

